const AddDebate = () => {
  return <div>AddDebate</div>
};

export default AddDebate;
